import { Category } from './';

export class NavigationItem {
  public static fromCategory(category: Category): NavigationItem {
    return new NavigationItem(category.name, category.route);
  }

  constructor(
    public name: string,
    public url: string,
    public parent?: NavigationItem,
    public onClick?: React.MouseEventHandler<HTMLAnchorElement>
  ) {}
}

export default NavigationItem;



// WEBPACK FOOTER //
// ./src/app/models/NavigationItem.ts